import {
  Box,
  ColorPreset,
  Field,
  FontWeight,
  Form,
  H4,
  TypePreset,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";
import { useForm } from "react-hook-form";
import { useState } from "react";

import { AcceptedDocuments } from "../../common/AcceptedDocuments";
import { HavingTroubleDialog } from "../../common/HavingTroubleDialog";
import { RequiredActionCardProps } from "../RequiredActionCard";
import { BankAccountFormValues } from "../../constants/DocumentRequirement";
import {
  DocumentVerifierContainer,
  VerifierState,
} from "../../common/document-verifier/DocumentVerifierContainer";

import { BankVerificationDocumentsRequirements } from "./BankVerificationDocumentsRequirements";

import Sentry from "src/technical-integrations/sentry/sentry";

export const BankDocumentVerifyAndUpload: React.FC<RequiredActionCardProps> = ({
  verificationId,
  acceptedDocuments,
  bankAccountNumberEnding,
}) => {
  const [documentVerifierState, setDocumentVerifierState] =
    useState<VerifierState | null>(null);

  const { handleSubmit } = useForm<BankAccountFormValues>();
  if (!bankAccountNumberEnding) {
    Sentry.captureMessage(
      `No account number available for bank account verification ${verificationId}`
    );
    return null;
  }

  const uploadSelectedDocuments = () => {
    setDocumentVerifierState(VerifierState.UploadDocument);
  };

  return (
    <Box>
      <AcceptedDocuments
        documents={acceptedDocuments}
        caller="bank_document_upload"
      />
      <Form onSubmit={handleSubmit(uploadSelectedDocuments)}>
        <Box spaceBelow={1} spaceAbove={1}>
          <Field>
            <Box
              spaceAbove={0.25}
              gutterV={1.5}
              gutterH={1.5}
              borderColor={ColorPreset.BorderOnLight_04}
              borderRadius={1}
              borderWidth={1}
            >
              <H4 preset={TypePreset.Heading_01} weight={FontWeight.Normal}>
                <Trans>
                  Documents in the form of PDFs are preferred, however we can
                  also accept photos and screenshots provided that they include
                  the following requirements:
                </Trans>
              </H4>

              <Box spaceAbove={1.5} spaceBelow={1.5}>
                <BankVerificationDocumentsRequirements
                  accountNumberEnding={bankAccountNumberEnding}
                />
              </Box>
            </Box>
          </Field>
        </Box>
        <DocumentVerifierContainer
          open={documentVerifierState === VerifierState.UploadDocument}
          documentVerifierState={documentVerifierState}
          setDocumentVerifierState={setDocumentVerifierState}
        />
      </Form>
      <HavingTroubleDialog
        sourceComponent={BankDocumentVerifyAndUpload.name}
        {...{ bankAccountNumberEnding }}
      />
    </Box>
  );
};
